module.exports = __webpack_public_path__ + "img/03mazda-hatchback-angle.11d09edd.png";